var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 19.1667C14.988 19.1667 19.1667 14.988 19.1667 9.83333C19.1667 4.67868 14.988 0.5 9.83333 0.5C4.67868 0.5 0.5 4.67868 0.5 9.83333C0.5 14.988 4.67868 19.1667 9.83333 19.1667Z",
    stroke: "#121212",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 16.4248L27.3341 27.3331",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/Loupe.2e0d6f9503b0980cbcf7300df96be391.svg";
export { ForwardRef as ReactComponent };